const NAMESPACE = 'DUCKS/SPLIT_TEST';

export default NAMESPACE;
